import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material'
import LaptopIcon from '@mui/icons-material/Laptop'
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'

interface Props {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuApprovals: FC<Props> = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}) => {
  const intl = useIntl()
  return (
    <MenuList disablePadding={true} onClick={toggleDrawerOnMobile}>
      <MenuItem
        key="approvals"
        data-test="hr-bots_sidebar_menuitem"
        component={ButtonLink}
        href="/hr-bot/equipment-approvals?page=1"
        selected={pathname.includes('hr-bot/equipment-approvals')}
        className={nested}
      >
        <ListItemIcon data-test="hr-bot_sidemenu_icon">
          <LaptopIcon />
        </ListItemIcon>
        <ListItemText
          primary={intl.formatMessage({
            id: 'approvals.sidebar',
          })}
        />
      </MenuItem>
    </MenuList>
  )
}
